<template>
  <div class="flex h-lg flex-row items-center bg-avtalat-gray">
    <div class="h-full basis-2/5 text-nowrap bg-white py-3xs">
      <ArrowButton
        @click="navigation.closeArendeView"
        text="Alla ärenden"
        variant="left"
      />
    </div>
    <div class="basis-1/5 text-nowrap">
      Öppna:
      <strong>{{
        arendeStore.openPreviewArenden.filter(
          (t) => t.id !== arendeStore.arende.data?.id,
        ).length
      }}</strong>
    </div>
    <div class="basis-1/5 text-nowrap">
      Stängda: <strong>{{ arendeStore.closedArenden.length }}</strong>
    </div>
    <div class="flex basis-1/5 text-nowrap">
      <button v-on:click="onClickToggle" :disabled="!isReady">
        Detaljer
        <FontAwesomeIcon
          class="text-avtalat-teal"
          :icon="
            expanded ? 'fa-regular fa-chevron-up' : 'fa-regular fa-chevron-down'
          "
        />
      </button>
    </div>
  </div>
  <div class="bg-avtalat-gray px-sm py-xs" v-if="expanded">
    <div
      class="flex justify-center"
      v-if="arendeStore.populatedArenden.isLoading"
    >
      <SmallSpinner />
    </div>
    <div
      v-if="
        !arendeStore.populatedArenden.isLoading &&
        arendeStore.populatedArenden.error
      "
    >
      <span>Det gick inte att hämta övriga ärenden.</span>
    </div>
    <div
      v-if="
        !arendeStore.populatedArenden.isLoading &&
        !arendeStore.populatedArenden.error
      "
    >
      <div v-if="arendeStore.openPreviewArenden">
        <strong>Öppna ärenden</strong>
      </div>
      <div class="flex flex-col">
        <PreviewArende
          v-for="arende in arendeStore.openPreviewArenden"
          :arende="arendeStore.getPopulatedArende(arende.id)"
          :onClickArende="onClickArende"
          :key="arende.id!"
        />
      </div>
      <div v-if="arendeStore.openPreviewArenden.length === 0">
        Det finns inga tidigare öppna ärenden
      </div>
      <div v-if="arendeStore.closedPreviewArenden">
        <strong>Stängda ärenden</strong>
      </div>
      <div class="flex flex-col">
        <PreviewArende
          v-for="arende in arendeStore.closedPreviewArenden"
          :arende="arendeStore.getPopulatedArende(arende.id)"
          :onClickArende="onClickArende"
          :key="arende.id!"
        />
      </div>
      <div v-if="arendeStore.closedPreviewArenden.length === 0">
        Det finns inga stängda ärenden
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed, inject, ref } from "vue";

import PreviewArende from "@/components/arende-components/PreviewArende.vue";
import ArrowButton from "@/components/ui/ArrowButton.vue";
import SmallSpinner from "@/components/ui/SmallSpinner.vue";
import { useApi } from "@/composables/useApi";
import { useNavigation } from "@/composables/useNavigation";
import type { SimpleArende } from "@/types/simpleArende";

import { useAnstalldarendeStore } from "../../store";

const navigation = useNavigation();
const apiClient = useApi();
const arendeStore = useAnstalldarendeStore();

const isReady = computed(
  () =>
    !arendeStore.arenden.isLoading && !arendeStore.populatedArenden.isLoading,
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const openArende = inject("openArende", (_arende: SimpleArende) => {});

const expanded = ref(false);

const onClickToggle = () => {
  expanded.value = !expanded.value;
  if (expanded.value) {
    arendeStore.ensurePreviewArenden(apiClient);
  }
};

const onClickArende = (arende: SimpleArende) => {
  openArende(arende);
  expanded.value = false;
};

library.add(faChevronDown, faChevronUp);
</script>
